<template>
  <!-- Layout con .page-container per coerenza con altre pagine -->
  <main id="create-client-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Form principale -->
    <form
      class="create-client-form"
      @submit.prevent="onUpdateClient"
      novalidate
    >
      <!-- RIGA 1: Nome Cliente, Codice fiscale, Telefono, PEC -->
      <div class="create-client-row row-1">
        <!-- [sc-48245] Stesse etichette e stessi obblighi di CreateClientPage:
             obbligatori nome e telefono, il resto no. -->
        <div class="field">
          <label for="client-name"
            >Nome e cognome <span class="required-mark">*</span></label
          >
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci nome e cognome..."
            required
          />
        </div>
        <!-- Codice fiscale -->
        <div class="field">
          <label for="fiscal-code">Codice fiscale</label>
          <input
            id="fiscal-code"
            type="text"
            v-model="formData.taxCode"
            placeholder="inserisci il codice fiscale..."
          />
        </div>
      </div>
      <div class="create-client-row row-2">
        <!-- Telefono -->
        <div class="field">
          <label for="phone"
            >Telefono <span class="required-mark">*</span></label
          >
          <input
            id="phone"
            type="text"
            v-model="formData.phoneNumber"
            placeholder="inserisci il numero di telefono..."
            required
          />
        </div>

        <div class="contact-right-group">
          <div class="field">
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              v-model="formData.email"
              placeholder="inserisci l'indirizzo email..."
            />
          </div>

          <div class="field">
            <label for="pec">PEC</label>
            <input
              id="pec"
              type="email"
              v-model="formData.pec"
              placeholder="inserisci l'indirizzo PEC..."
            />
          </div>
        </div>
      </div>

      <hr />

      <!-- RIGA 3: Ragione Sociale + P.IVA -->
      <div class="create-client-row row-3">
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci"
          />
        </div>
      </div>

      <!-- RIGA 4: Codice univoco + Sede Legale -->
      <div class="create-client-row row-4">
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="lh-address">Sede legale</label>
          <input
            type="text"
            id="lh-address"
            v-model="formData.legalHeadquarters.address"
            placeholder="inserisci l'indirizzo della sede legale..."
            autocomplete="off"
            @keydown.enter.prevent
          />
        </div>
      </div>

      <hr />

      <div class="save-button-container">
        <button
          id="create-client-button"
          class="primary-btn"
          type="submit"
          :disabled="!canSave"
          :title="
            !canSave ? 'Modifica almeno uno dei campi' : 'Aggiorna cliente'
          "
        >
          Aggiorna
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";

// 👇 accetta sia stringa JSON che oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
};

export default {
  name: "EditClientPage",
  beforeRouteLeave(to) {
    if (this.navigationConfirmed || to.name === "login" || !this.isDirty) {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  props: ["clientId"],
  computed: {
    // [sc-48245] Obbligatori solo nome e telefono, come in creazione. Sui
    // clienti già registrati il vincolo su codice fiscale ed email era anche
    // peggio che in creazione: bloccava il salvataggio di qualunque modifica
    // finché non si compilavano campi che nessuno aveva.
    hasRequiredFields() {
      const f = this.formData;
      return !!(f.clientName || "").trim() && !!(f.phoneNumber || "").trim();
    },
    canSave() {
      return this.hasRequiredFields && this.isDirty;
    },
    // true solo se lo stato differisce dallo snapshot iniziale.
    isDirty() {
      if (!this.originalSig) return false;
      return this.computeSignature() !== this.originalSig;
    },
  },
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      formData: {
        clientName: "",
        taxCode: "",
        phoneNumber: "",
        uniqueCode: "",
        companyName: "",
        vatNumber: "",
        email: "",
        pec: "",
        legalHeadquarters: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
        },
      },
      // tracking modifiche per il pulsante salva
      originalSig: "",

      errorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      // Nessuna modifica: torna indietro senza conferma.
      if (!this.isDirty) {
        this.navigationConfirmed = true;
        this.$router.back();
        return;
      }
      this.showBackModal = true;
    },
    // Guardia reload/chiusura tab nativa del browser: dialog nativo di
    // conferma solo se ci sono modifiche non salvate.
    handleBeforeUnload(e) {
      if (!this.isDirty) return;
      e.preventDefault();
      e.returnValue = "";
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    ...mapActions(["updateClient"]),

    normalizeForCompare() {
      const f = this.formData || {};
      const H = f.legalHeadquarters || {};
      // Modello solo-indirizzo (Google Places rimosso): la modifica va
      // rilevata sull'indirizzo, non più su placeId/lat/lng (sempre vuoti).
      const address = (H.address || "").trim();
      const hq = address ? { address } : null;

      return {
        clientName: f.clientName || "",
        taxCode: f.taxCode || "",
        phoneNumber: f.phoneNumber || "",
        uniqueCode: f.uniqueCode || "",
        companyName: f.companyName || "",
        vatNumber: f.vatNumber || "",
        pec: f.pec || "",
        email: f.email || "",
        legalHeadquarters: hq,
      };
    },
    computeSignature() {
      return JSON.stringify(this.normalizeForCompare());
    },
    captureSnapshot() {
      this.originalSig = this.computeSignature();
    },

    /**
     * Recupera i dati dell'cliente da modificare.
     * Viene chiamato appena il componente è montato.
     */
    async fetchClientData() {
      try {
        this.errorMessage = "";
        const response = await this.$axios.get(`client/${this.clientId}`);
        // console.log("client data response: ", response);
        // Adatta il percorso a seconda della tua API
        if (response.status === 200) {
          // Popola i campi con i dati ottenuti
          const clientData = response.data.client;
          this.formData.clientName = clientData.clientName;
          this.formData.taxCode = clientData.taxCode;
          this.formData.phoneNumber = clientData.phoneNumber;
          this.formData.uniqueCode = clientData.uniqueCode;
          this.formData.companyName = clientData.companyName;
          this.formData.vatNumber = clientData.vatNumber;
          this.formData.pec = clientData.pec;
          this.formData.email = clientData.email;
          this.formData.legalHeadquarters = asLoc(
            clientData.legalHeadquarters
          ) || {
            name: "",
            address: "",
            placeId: "",
            latitude: "",
            longitude: "",
          };

          this.$nextTick(() => {
            this.successMessage = `Dati del cliente con ID:${this.clientId} caricati con successo`;
            this.$toast.success(this.successMessage);
            this.captureSnapshot(); // stato iniziale caricato
          });
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Impossibile caricare i dati del cliente.";
        this.$toast.error(this.errorMessage);
      }
    },

    async onUpdateClient() {
      try {
        this.errorMessage = "";
        this.successMessage = "";

        // Puoi usare un FormData se devi inviare anche file (immagine),
        // altrimenti un JSON semplice se l'API lo consente.
        const payload = {
          clientName: this.formData.clientName,
          taxCode: this.formData.taxCode,
          phoneNumber: this.formData.phoneNumber,
          uniqueCode: this.formData.uniqueCode,
          companyName: this.formData.companyName,
          vatNumber: this.formData.vatNumber,
          email: this.formData.email,
          pec: this.formData.pec,
          legalHeadquarters: this.formData.legalHeadquarters,
        };

        if (!payload.legalHeadquarters?.address?.trim()) {
          delete payload.legalHeadquarters;
        }

        // Esempio di richiesta PATCH
        const response = await this.updateClient({
          clientId: this.clientId,
          payload,
        });

        if (response.status === 200) {
          await this.$store.dispatch("fetchClients");

          this.successMessage =
            response.data?.message || "Cliente aggiornato con successo!";
          this.$toast.success(this.successMessage);

          // redirect alla pagina clients
          setTimeout(() => {
            this.navigationConfirmed = true;
            this.$router.push({ name: "customers" });
          }, 1000);
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409) {
          // Gestisci il conflitto
          this.errorMessage =
            error.response.data?.details ||
            "Conflitto nei dati, chiave univoca 'Ragione sociale' già presente.";
          this.$toast.error(this.errorMessage);
        } else {
          this.errorMessage =
            error.response?.data?.details ||
            error.response?.data?.error ||
            "Errore durante l'aggiornamento del cliente.";
          this.$toast.error(this.errorMessage);
        }
        this.successMessage = "";
      }
    },
  },
  /**
   * Appena montato, recupera i dati dall'API
   */
  mounted() {
    this.fetchClientData();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
